import { render, staticRenderFns } from "./BacklogByLocation.vue?vue&type=template&id=0d5f6b4b&scoped=true&"
import script from "./BacklogByLocation.vue?vue&type=script&lang=js&"
export * from "./BacklogByLocation.vue?vue&type=script&lang=js&"
import style0 from "./BacklogByLocation.vue?vue&type=style&index=0&id=0d5f6b4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f6b4b",
  null
  
)

export default component.exports